import React from "react";
import DashboardLayout from "../components/DashboardLayout";

function Help() {
  return (
    <DashboardLayout headerTitle="Help">
      <div className="mt-[20px] text-center">Page Contents</div>
    </DashboardLayout>
  );
}

export default Help;
